export class RedshiftServerlessNamespace {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "namespaceName",
            "baseName": "namespaceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "namespaceId",
            "baseName": "namespaceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RedshiftServerlessNamespace.attributeTypeMap;
    }
    constructor() {
    }
}
